export interface CaseCategory {
  id: string;
  name: string;
}

export const defaultCaseCategories: CaseCategory[] = [
  { id: "commercial", name: "Commercial" },
  { id: "residential", name: "Residential" },
  { id: "hospitality", name: "Hospitality" },
  { id: "retail", name: "Retail" },
  { id: "institutional", name: "Institutional" },
  { id: "mixed-use", name: "Mixed-Use" },
];
